import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import type { DropzoneRootProps } from 'react-dropzone';
import Flex from '@wix/da-ds/pkg/Flex/Flex';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { UploaderVariant, VARIANT_CONFIG } from '../types';
import UploadingLoader from '../UploadingLoader';

import s from './EmptyState.scss';

interface Props {
  variant: UploaderVariant;
  isUploading: boolean;
  hasError?: boolean;
  uploadProgress?: number;
  getDropzoneRootProps: () => DropzoneRootProps;
}

const EmptyState: React.FC<Props> = ({
  variant,
  isUploading,
  hasError,
  uploadProgress,
  getDropzoneRootProps,
}) => {
  const { t } = useTranslation();
  const { emptyLoaderState, emptyStateClass, emptyStateTitleKey, emptyStateSubtitleKey } =
    VARIANT_CONFIG[variant];

  if (isUploading) {
    return <UploadingLoader uploadProgress={uploadProgress} variant={variant} />;
  }

  return (
    <Flex direction="column" alignItems="center" {...getDropzoneRootProps()}>
      {emptyLoaderState && <Loader size="big" state={emptyLoaderState} />}
      {emptyStateClass && <div className={s[emptyStateClass]} />}
      <span className={s['title']}>{t(emptyStateTitleKey)}</span>
      <span className={c(s['text'], hasError && s['has-error'])}>{t(emptyStateSubtitleKey)}</span>
      <GhostButton className={s['add-btn']} variant="main" size="large">
        {t('originalDeviationPopup.form.coverImage.btn')}
      </GhostButton>
    </Flex>
  );
};
EmptyState.displayName = 'EmptyState';

export default EmptyState;
